import { call, put, takeEvery, select } from "redux-saga/effects";
import {
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../../helpers/utils";
import {
  ADD_CAMPAIGN_CASHBACKS,
  DELETE_CAMPAIGN_CASHBACKS,
  GET_CAMPAIGN_CASHBACK_PROFILE,
  GET_CAMPAIGN_CASHBACKS_LIST,
  UPDATE_CAMPAIGN_CASHBACK_PROFILE,
} from "./actionTypes";
import {
  getCampaignCashbacksList,
  hideCampaignCashbacksListLoader,
  setCampaignCashbackProfile,
  setCampaignCashbacksList,
  showCampaignCashbacksListLoader,
} from "./actions";
import {
  deleteCampaignCashback,
  getCampaignCashbackProfile,
  getCampaignCashbacks,
  postCampaignCashback,
  putCampaignCashbackProfile,
} from "../../../helpers/jwt_helper";

// Chat Redux States
function* onGetCampaignCashbackList({ payload: data }) {
  try {
    yield put(showCampaignCashbacksListLoader());
    let response = yield call(getCampaignCashbacks, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
    });

    response.results.forEach(item => {
      item.geos = item.regions.map(i => {
        return i.countries.join(", ");
      });
      item.dateRange = item.date_from + " - " + item.date_to;
    });

    response = {
      ...data,
      ...response,
    };

    yield put(setCampaignCashbacksList(response));
    yield put(hideCampaignCashbacksListLoader());
  } catch (error) {
    yield put(hideCampaignCashbacksListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddCampaignCashback({ payload: { cashback } }) {
  try {
    yield put(showCampaignCashbacksListLoader());
    yield call(postCampaignCashback, { ...cashback });
    yield call(onGetCampaignCashbackList, {
      payload: yield select(state => state.CampaignCashbackList.data),
    });
    yield put(hideCampaignCashbacksListLoader());
    showSuccessMessage("Campaign cashback has been added");
  } catch (error) {
    yield put(hideCampaignCashbacksListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteCashback({ payload: { id, data } }) {
  try {
    yield put(showCampaignCashbacksListLoader());
    yield call(deleteCampaignCashback, id);
    yield call(onGetCampaignCashbackList, { payload: data });
    yield put(hideCampaignCashbacksListLoader());
    showSuccessMessage("Campaign cashback has been deleted");
  } catch (error) {
    yield put(hideCampaignCashbacksListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetCampaignCashbackProfile({ payload: id }) {
  try {
    yield put(showCampaignCashbacksListLoader());
    let response = yield call(getCampaignCashbackProfile, id);
    yield put(setCampaignCashbackProfile(response));
    yield put(hideCampaignCashbacksListLoader());
  } catch (error) {
    yield put(hideCampaignCashbacksListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onUpdateCampaignCashbackProfile({ payload: { id, cashback, data } }) {
  try {
    yield put(showCampaignCashbacksListLoader());
    yield call(putCampaignCashbackProfile, id, { ...cashback });
    yield call(getCampaignCashbacksList, { payload: data });
    yield put(hideCampaignCashbacksListLoader());
    yield put(setCampaignCashbackProfile(null));
    showSuccessMessage("Campaign cashback has been updated");
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* campaignCashbackListSaga() {
  yield takeEvery(GET_CAMPAIGN_CASHBACKS_LIST, onGetCampaignCashbackList);
  yield takeEvery(DELETE_CAMPAIGN_CASHBACKS, onDeleteCashback);
  yield takeEvery(ADD_CAMPAIGN_CASHBACKS, onAddCampaignCashback);
  yield takeEvery(GET_CAMPAIGN_CASHBACK_PROFILE, onGetCampaignCashbackProfile);
  yield takeEvery(
    UPDATE_CAMPAIGN_CASHBACK_PROFILE,
    onUpdateCampaignCashbackProfile
  );
}

export default campaignCashbackListSaga;
